import { differenceInMilliseconds } from 'owa-datetime';
import CalendarEvent from 'owa-calendar-types/lib/types/CalendarEvent';
import TimeConstants from 'owa-datetime-utils/lib/TimeConstants';

/**
 * Whether the item is an all-day or multi-day event > 24h event
 * @param item The surface item model
 * @returns True if the item is multi day, false otherwise
 */
export default function isItemMultiDay(item: CalendarEvent) {
    return (
        item.IsAllDayEvent ||
        differenceInMilliseconds(item.End, item.Start) >= TimeConstants.MillisecondsInOneDay
    );
}
